import { Logout } from "@mui/icons-material";
import {
    Box,
    Button,
    Menu,
    MenuItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Avatar,
} from "@mui/material";
import * as React from "react";

interface UserMenuProps {
    name: string;
    onSignOut: () => void;
}

export function UserMenu({ name, onSignOut }: UserMenuProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{ flexGrow: 0 }}>
            <Button
                onClick={handleOpen}
                endIcon={
                    <Avatar
                        src="/broken-image.jpg"
                        sx={{ width: 32, height: 32 }}
                    />
                }
            >
                {name}
            </Button>

            <Menu
                variant="selectedMenu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
            >
                <MenuItem disableGutters sx={{ padding: 0 }}>
                    <ListItemButton
                        onClick={() => {
                            handleClose();
                            onSignOut();
                        }}
                    >
                        <ListItemIcon sx={{ color: "inherit" }}>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Sair da conta" />
                    </ListItemButton>
                </MenuItem>
            </Menu>
        </Box>
    );
}
